export default __webpack_public_path__ + "static/media/shape-highlighted.e0bc1c7f.svg";